'use client'

import { Builder } from '@builder.io/react'

import { Reviews } from './Reviews'
import { defaults } from './Reviews.defaults'

Builder.registerComponent(Reviews, {
  name: 'Reviews',
  inputs: [
    {
      name: 'slots',
      friendlyName: 'Reviews',
      type: 'list',
      defaultValue: defaults.slots,
      subFields: [
        {
          name: 'name',
          type: 'string',
          defaultValue: 'Slot name',
          helperText: 'The name of the slot to render.',
        },
        {
          name: 'width',
          type: 'number',
          defaultValue: 250,
          helperText: 'The width of the slot.',
        },
        {
          name: 'content',
          type: 'uiBlocks',
          hideFromUI: true,
          defaultValue: [],
        },
      ],
    },
  ],
  image: 'https://unpkg.com/@tabler/icons@2.44.0/icons/stars.svg',
})
